import { getSupportedLanguages } from 'i18n-iso-countries';

import { ValueOf } from '../utilities/types';

const languages = {
  SV: 'sv',
  EN: 'en',
  DE: 'de',
} as const;

export type Languages = ValueOf<typeof languages>;

export const toTextLanguage = (language: string): Languages => (
  Object.values(languages).find((textLanguage) => textLanguage === language) ?? languages.EN
);

const LANGUAGE_NAMES = new Intl.DisplayNames(['en'], { type: 'language' });

export const languagesChoices = [...new Set(getSupportedLanguages())]
  .map((id) => ({ id, name: LANGUAGE_NAMES.of(id) ?? id }))
  .sort((a, b) => a.name.localeCompare(b.name));

export default languages;
